import { Injectable, inject } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateParser } from '@ngx-translate/core';

// A key with no translation yet shows as itself, as before, but with its {{params}} filled in.
@Injectable()
export class InterpolatingMissingTranslationHandler implements MissingTranslationHandler {
  private parser = inject(TranslateParser);

  handle({ key, interpolateParams }: MissingTranslationHandlerParams): string {
    return this.parser.interpolate(key, interpolateParams) ?? key;
  }
}
